import { DateCell } from '../TableCells/DateCell';
import CheckboxCell from '../TableCells/CheckboxCell';
import { ValueCell } from '../TableCells/ValueCell';

export const fixProblemTableColumns = ({ updateValue, qboMappingId }) => [
  {
    Header: '',
    accessor: 'checkbox',
    width: 5,
    Cell: (props) => (
      <CheckboxCell {...props} updateValue={updateValue} qboMappingId={qboMappingId} />
    ),
  },
  {
    Header: 'Name',
    accessor: 'name',
    width: 25,
    Cell: ValueCell,
  },
  {
    Header: 'Entity Type',
    accessor: 'quickBooksEntityType',
    width: 15,
  },
  {
    Header: 'QBO ID',
    accessor: 'quickBooksId',
    width: 25,
    Cell: ValueCell,
  },
  {
    Header: 'Created Date',
    accessor: 'createdAt',
    width: 15,
    Cell: DateCell,
  },
  {
    Header: 'Updated Date',
    accessor: 'lastUpdatedAt',
    width: 15,
    Cell: DateCell,
  },
];
